<template>
    <svg focusable="false"  class="icon x-icon" width="27px" height="29px" viewBox="0 0 27 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <desc>Created with Sketch.</desc>
        <g class="UI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
            <g class="cmhr-edu-resource-toolkit-01B-landing-2.0" transform="translate(-1194.000000, -391.000000)" stroke="#232323" stroke-width="2">
                <g class="intro" transform="translate(0.000000, 174.000000)">
                    <g class="search-field">
                        <g class="close-x" transform="translate(1195.000000, 218.000000)">
                            <path d="M24.5,0.518867925 L0.5,26.4622642" class="Line"></path>
                            <path d="M24.5,0.518867925 L0.5,26.4622642" class="Line-Copy" transform="translate(12.500000, 13.490566) scale(-1, 1) translate(-12.500000, -13.490566) "></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<style scoped lang="scss">
    svg {
        height: 27px;
        width: 25px;
    }
</style>

<script>
    export default {
        name: "XIcon"
    }
</script>
